'use client';
import { ChangeEventHandler, useEffect, useState } from 'react';
import styles from './progress-bar.module.scss';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setUserCurrentTime } from 'store/slices/player.slices';
import { convertToMinutes } from '../../../../../libs/utils/convert-to-minutes';
import { getBlindMode } from '../../../../../store/slices/blind-mode.slices';
import clsx from 'clsx';

export const ProgressBar = () => {
  const dispath = useAppDispatch();
  const { blindWrapClass } = useAppSelector(getBlindMode);
  const [timeToTrack, setTimeToTrack] = useState({ durationTrack: '', currentTrack: '' });
  const { currentPercentage, duration, currentTime, description } = useAppSelector(
    (store) => store.player,
  );

  useEffect(() => {
    const durationTrack = convertToMinutes(duration);
    const currentTrack = convertToMinutes(currentTime);
    setTimeToTrack((pre) => ({ ...pre, durationTrack, currentTrack }));
  }, [currentTime, duration]);

  /* Устанавливает точную позицию прогресс бара по клику */
  const onChange: ChangeEventHandler<HTMLInputElement> = ({ target }) => {
    dispath(setUserCurrentTime(Number(target.value)));
  };

  return (
    <article className={clsx(styles.bar, { [styles.blindWrapClass]: blindWrapClass })}>
      <input
        type="range"
        min={0}
        value={currentPercentage || 0}
        max={duration || 0}
        onChange={onChange}
        className={styles.input}
      />
      {/* прогресс бар клик по которому перемещается трек по времени */}
      <div
        className={clsx(styles.progress, { [styles.blindWrapClass]: blindWrapClass })}
        style={{ transform: `scaleX(${currentPercentage})` }}
      />
      <p
        className={clsx(styles.timeProgress, { [styles.blindWrapClass]: blindWrapClass })}
      >
        {!Number.isFinite(duration) || duration === 0
          ? 'Прямой эфир'
          : timeToTrack.currentTrack + '/' + timeToTrack.durationTrack}
      </p>
      {/* имитация прогресс бара */}
      <div className={styles.bg} />
      {/* бекграунд за имитацией прогрессбара */}
    </article>
  );
};
